<template>
  <div id="app">
    <!-- 
      Komponen <router-view> adalah 'jendela' tempat Vue Router akan 
      menampilkan komponen yang sesuai dengan URL saat ini.
      Jika URL adalah '/', ia akan menampilkan CodeEntry.vue.
      Jika URL adalah '/dashboard', ia akan menampilkan TestDashboard.vue.
    -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  // Hapus semua data() dan methods() yang lama. Biarkan kosong.
};
</script>

<style>
/* 
  Anda bisa menaruh style global (yang berlaku di semua halaman) di sini.
  Contohnya, style untuk body, container utama, dll.
*/
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* Hapus text-align: center; jika tidak ingin semua halaman rata tengah */
}

/* src/App.vue -> <style> (bukan scoped) */

/* Style Global untuk Konten Tiptap Editor */
.ProseMirror {
  outline: none;
}

.ProseMirror p {
  margin: 0 0 0.5rem 0;
}

.ProseMirror ul,
.ProseMirror ol {
  padding-left: 20px;
  margin: 0.5rem 0;
}

.ProseMirror li {
  margin-bottom: 0.25rem;
}

.ProseMirror strong {
  font-weight: bold;
}

.ProseMirror em {
  font-style: italic;
}
</style>

